var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "control-group" }, [
    _c("label", { attrs: { for: _vm.inputId } }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: _vm.icon, alt: _vm.label + " icon" },
      }),
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
    ]),
    _c("div", { staticClass: "slider-wrapper" }, [
      _c("input", {
        staticClass: "slider",
        style: _vm.sliderStyles,
        attrs: {
          id: _vm.sliderId,
          type: "range",
          min: _vm.SLIDER_CONFIG.MIN_PERCENT,
          max: _vm.SLIDER_CONFIG.MAX_PERCENT,
          step: _vm.SLIDER_CONFIG.STEP,
        },
        domProps: { value: _vm.sliderValue },
        on: { input: _vm.onSliderInput },
      }),
      _c("input", {
        staticClass: "number-input",
        attrs: {
          id: _vm.inputId,
          type: _vm.isCustomValue ? "text" : "number",
          min: _vm.minValue,
          max: _vm.maxValue,
          readonly: _vm.isCustomValue,
        },
        domProps: { value: _vm.displayValue },
        on: { input: _vm.onInputChange },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }